import { Button, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { TABS } from '../../../../Page/customer/customerMeetingsPage';

interface MeetingHeaderProps {
  selectedTab: number;
  setSelectedTab: (value: number) => void;
}

const buttonStyle = {
  fontFamily: 'Schibsted Grotesk',
  color: 'gray',
  fontSize: '.9rem',
  padding: '1rem 1.2rem',
  textTransform: 'none',
  borderRadius: '6px 0px 0px 0px',
};




const MeetingHeader = ({ selectedTab, setSelectedTab }: MeetingHeaderProps) => {

  const changeTabHandler = (selected: number) => {
    setSelectedTab(selected);
  };

  return (
    <Stack direction='row'>
      <Button
        sx={{
          ...buttonStyle,
          ...(selectedTab === TABS.SCHEDULED ? {
            color: '#00CECF',
            background: '#00CECF1F',
            borderBottom: '4px solid #00CECF',
          } : {
            color: 'gray',
            background: 'transparent',
            borderBottom: 'none',
          }),
        }}
        onClick={() => changeTabHandler(TABS.SCHEDULED)}
      >
        <FormattedMessage defaultMessage='Scheduled' />
      </Button>
      <Button
        sx={{
          ...buttonStyle,
          ...(selectedTab === TABS.AVAILABILITY ? {
            color: '#00CECF',
            background: '#00CECF1F',
            borderBottom: '4px solid #00CECF',
          } : {
            color: 'gray',
            background: 'transparent',
            borderBottom: 'none',
          }),
        }}
        onClick={() => changeTabHandler(TABS.AVAILABILITY)}
      >
        <FormattedMessage defaultMessage='Availability' />
      </Button>
    </Stack>
  );
};

export default MeetingHeader;